export default __webpack_public_path__ + "static/media/Left001.81ad236b.png";